<footer class="footer">
  <ng-container *ngIf="disclaimer">
    <div class="disclaimer">      
      <div class="col-1">Disclaimer</div>
      <div class="col-2">
        Please note that this is the new page for Deloitte U.S. applications.
        Please follow the prompts to be authenticated. <a class="link-text" href="">Read more.</a>                
      </div>
      <span class="close" (click)="closeDisclaimer()">×</span>
    </div>
  </ng-container>  
  <div class="footerMenu">
    <ul>
      <li>Terms of use</li>
      <li>Privacy & Cookies</li>
      <li>Help Centre</li>
    </ul>
  </div>
  <div class="copyright">
    <p>© 2025 Deloitte Spark. All rights reserved.</p>
    <p>
      Deloitte Touche Tohmatsu India Private Limited (U74140MH199 5PTC093339) a
      private company limited by shares was converted into Deloitte Touche
      Tohmatsu India LLP, a limited liability partnership (LLP Identification
      No. AAE-8458) with effect from October 1, 2015.
    </p>
    <p>
      Deloitte refers to one or more of Deloitte Touche Tohmatsu Limited, a UK
      private company limited by guarantee (“DTTL”), its network of member
      firms, and their related entities. DTTL and each of its member firms are
      legally separate and independent entities. DTTL (also referred to as
      “Deloitte Global”) does not provide services to clients. Please see
      www.deloitte.com/about to learn more about our global network of member
      firms.
    </p>
  </div>
</footer>
